// extracted by mini-css-extract-plugin
module.exports = {"block":"_3cf9652","container":"_8e0d5a2"};